import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'truncate'
})
export class TruncatePipe implements PipeTransform {

    transform(input: any, length?: number, suffix?: string, preserve?: boolean): any {
        if (typeof input !== 'string') {
            return input;
        }
        length = typeof length === 'undefined' ? input.length : length;
        if (input.length <= length) {
            return input;
        }
        preserve = preserve || false;
        suffix = suffix || '';
        let index = length;
        if (preserve) {
            index = (input.indexOf(' ', length) === -1) ? input.length : input.indexOf(' ', length);
        }
        return input.substring(0, index) + suffix;
    }
}
